import hoistNonReactStatic from 'hoist-non-react-statics';
import PropTypes from 'prop-types';
import React from 'react';
import {
  NavigateFunction,
  Params,
  useNavigate,
  useParams,
} from 'react-router-dom';

import {getDisplayName} from 'src/js/common/utils/component_utils';

export interface InjectNavigateExtraProps {
  navigate: NavigateFunction;
  routeParams: Readonly<Params<string>>;
}

function injectNavigate<P>(
  WrappedComponent: React.ComponentType<P & InjectNavigateExtraProps>
) {
  const InjectNavigate = (props: P) => {
    const navigate = useNavigate();
    const routeParams = useParams();

    return (
      <WrappedComponent
        navigate={navigate}
        routeParams={routeParams}
        {...props}
      />
    );
  };

  InjectNavigate.displayName = `InjectNavigate(${getDisplayName(
    WrappedComponent
  )})`;
  InjectNavigate.WrappedComponent = WrappedComponent;

  InjectNavigate.contextTypes = {
    navigate: PropTypes.objectOf(PropTypes.any),
    routeParams: PropTypes.objectOf(PropTypes.any),
  };

  hoistNonReactStatic(InjectNavigate, WrappedComponent);

  return InjectNavigate;
}

export default injectNavigate;
